import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { booking, navItems } from "../data/redlandGolfContent";
import { ButtonLink } from "./ButtonLink";

export function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [juniorOpen, setJuniorOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  const isActive = (href) => {
    if (!href) return false;
    return href === "/" ? pathname === href : pathname.startsWith(href);
  };

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`.trim()} data-testid="site-header">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div className="site-header-inner">
        <Link className="brand" to="/" aria-label="Redland Golf & Country Club home" data-testid="brand-home-link">
          <span className="brand-mark" aria-hidden="true">
            RGCC
          </span>
          <span className="brand-text">
            <span>Redland Golf</span>
            <span>&amp; Country Club</span>
          </span>
        </Link>

        <nav className="desktop-nav" aria-label="Primary navigation">
          {navItems.map((item) =>
            item.children ? (
              <div className="nav-dropdown" key={item.label}>
                <button
                  className={`nav-link nav-button ${
                    item.children.some((child) => isActive(child.href)) ? "is-active" : ""
                  }`.trim()}
                  type="button"
                  aria-haspopup="true"
                  data-testid="nav-junior-toggle"
                >
                  {item.label}
                  <span aria-hidden="true">v</span>
                </button>
                <div className="dropdown-panel" role="menu">
                  {item.children.map((child) => (
                    <Link
                      to={child.href}
                      key={child.href}
                      role="menuitem"
                      className={isActive(child.href) ? "is-active" : ""}
                      aria-current={isActive(child.href) ? "page" : undefined}
                      data-testid={`nav-link-${child.href}`}
                    >
                      {child.label}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                className={`nav-link ${isActive(item.href) ? "is-active" : ""}`.trim()}
                to={item.href ?? "/"}
                key={item.label}
                aria-current={isActive(item.href) ? "page" : undefined}
                data-testid={`nav-link-${item.href}`}
              >
                {item.label}
              </Link>
            )
          )}
          <Link className="nav-link nav-admin" to="/admin" data-testid="nav-admin-link">
            Admin
          </Link>
        </nav>

        <div className="desktop-cta">
          <ButtonLink href={booking.href} variant="primary" ariaLabel={booking.note}>
            Book a Tee Time
          </ButtonLink>
        </div>

        <button
          className="mobile-menu-button"
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((open) => !open)}
          data-testid="mobile-menu-button"
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </button>
      </div>

      <div className={`mobile-panel ${mobileOpen ? "is-open" : ""}`} data-testid="mobile-panel">
        <nav aria-label="Mobile navigation">
          {navItems.map((item) =>
            item.children ? (
              <div className="mobile-junior" key={item.label}>
                <button
                  type="button"
                  onClick={() => setJuniorOpen((open) => !open)}
                  aria-expanded={juniorOpen}
                  data-testid="mobile-junior-toggle"
                >
                  {item.label}
                  <span aria-hidden="true">{juniorOpen ? "-" : "+"}</span>
                </button>
                {juniorOpen ? (
                  <div className="mobile-subnav">
                    {item.children.map((child) => (
                      <Link
                        to={child.href}
                        key={child.href}
                        className={isActive(child.href) ? "is-active" : ""}
                        aria-current={isActive(child.href) ? "page" : undefined}
                        onClick={() => setMobileOpen(false)}
                        data-testid={`mobile-nav-link-${child.href}`}
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                ) : null}
              </div>
            ) : (
              <Link
                to={item.href ?? "/"}
                key={item.label}
                className={isActive(item.href) ? "is-active" : ""}
                aria-current={isActive(item.href) ? "page" : undefined}
                onClick={() => setMobileOpen(false)}
                data-testid={`mobile-nav-link-${item.href}`}
              >
                {item.label}
              </Link>
            )
          )}
          <Link to="/admin" className="mobile-admin-link" onClick={() => setMobileOpen(false)} data-testid="mobile-nav-admin-link">
            Admin
          </Link>
          <ButtonLink href={booking.href} variant="primary" className="mobile-book">
            Book a Tee Time
          </ButtonLink>
        </nav>
      </div>
    </header>
  );
}
